var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37",
    "data-name": "Group 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.309,
    height: 64.03,
    viewBox: "0 0 50.309 64.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3512",
    "data-name": "Rectangle 3512",
    width: 50.309,
    height: 64.03,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M48.3,22.2,28.109,2.012A6.87,6.87,0,0,0,23.261,0H6.86A6.863,6.863,0,0,0,0,6.86V57.169a6.863,6.863,0,0,0,6.86,6.86H43.449a6.863,6.863,0,0,0,6.86-6.86V27.048A6.871,6.871,0,0,0,48.3,22.2m-5.79.668H29.728a2.288,2.288,0,0,1-2.287-2.287V7.8Zm3.229,34.3a2.288,2.288,0,0,1-2.287,2.287H6.86a2.288,2.288,0,0,1-2.287-2.287V6.86A2.288,2.288,0,0,1,6.86,4.574H22.868V20.581a6.863,6.863,0,0,0,6.86,6.86H45.736Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M32.728,19.647H5.287a2.287,2.287,0,1,0,0,4.574H32.728a2.287,2.287,0,1,0,0-4.574M3,12.787a2.288,2.288,0,0,0,2.287,2.287H32.728a2.287,2.287,0,1,0,0-4.574H5.287A2.288,2.288,0,0,0,3,12.787M19.007,28.794H5.287a2.287,2.287,0,1,0,0,4.574H19.007a2.287,2.287,0,1,0,0-4.574",
    transform: "translate(6.147 21.515)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/application-icon.21148ce1e51e80c89ac3339191346503.svg";
export { ForwardRef as ReactComponent };